import { render, staticRenderFns } from "./ResultsOverview.vue?vue&type=template&id=f61dfdce"
import script from "./ResultsOverview.vue?vue&type=script&lang=ts"
export * from "./ResultsOverview.vue?vue&type=script&lang=ts"
import style0 from "./ResultsOverview.vue?vue&type=style&index=0&id=f61dfdce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports